module.exports = __webpack_public_path__ + "static/media/amr222.657f48ec.jpg";